import React, { Component } from "react";
import {
  Button, Card, CardBody, CardHeader, Col, Row,
  ButtonToolbar, ButtonGroup, ModalHeader, ModalBody, ModalFooter, Modal
} from "reactstrap";
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import LoadingIcon from "mdi-react/LoadingIcon";
import ReactTable from "react-table";

import {
  loadFeedbackList,
  openFeedback,
  createOrUpdateFeedback,
  deleteFeedback,
} from "../../../../../redux/actions/feedbackActions";
import FeedbackForm from './FeedbackForm';
import DeletePopUP from "../../../../../shared/components/deletePopUp";

export class MaintenanceOrFeedbackHistoryList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      showDeleteAlert: false,
      selectedFeedback: null,
      modal: false,
    };
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  };

  componentWillMount() {
    const { selectedComponent, loadFeedbackList } = this.props;
    if (selectedComponent){
        const component_id = selectedComponent._id;
        loadFeedbackList({component_id});
    } else{
        console.log("Mounted component without selected component");
    }
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.feedbackList){
      this.setState ({
        dataLoaded:true,
        formType: null,
        showDeleteAlert: false,
        selectedFeedback:null
      });
    }
  };

  openForm = (type, selectedFeedback) => {
    if (selectedFeedback){
      selectedFeedback["formType"]= type;
      this.props.openFeedback(selectedFeedback);
    } else{
      this.props.openFeedback(null);
    }

    this.toggle();
  };

  renderActionButtons = row => {
    return (
      <div className="text-center">
        <ButtonToolbar>
          <ButtonGroup className="btn-group--icons" dir="ltr">
            <Button
              outline color="success"
              onClick={() => this.openForm("update", row)}
            >
              <span className="lnr lnr-pencil" />
            </Button>
            <Button
              outline color="warning"
              onClick={() => this.openForm("clone", row)}
            >
              <span className="lnr lnr-plus-circle" />
            </Button>
            <Button
              outline color="danger"
              onClick={() =>
                this.setState({
                  showDeleteAlert: true,
                  selectedFeedback: row
                }, () => console.log('delete state: ', this.state))
              }
            >
              <span className="lnr lnr-cross" />
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    );
  };

  renderActionButton2 = props => {
    return (
      <div className="text-right">
        <Button
          className="icon"
          color="primary"
          onClick={() => this.openForm("create")}
        >
          <p>Provide New Feedback or Maintenance Action</p>
        </Button>
      </div>
    );
  };

  handleCreate = dataObj => {
    const data = JSON.parse(JSON.stringify(dataObj));
    if ( data && Object.keys(data).length > 0 ) {
      data.feedback_type =
        data.feedback_type && data.feedback_type.value && data.feedback_type.value !== undefined
          ? data.feedback_type.value : data.feedback_type;

      if (data.feedback_type) {
        const maintenanceFeedbackObj = {};
        const faultFeedbackObj = {};
        const failureFeedbackObj = {};

        if (data.feedback_type === "MAINTENANCE") {
          data.maintenance_feedback.map( maintenance =>
            maintenanceFeedbackObj[maintenance.label] = maintenance.value
          );
          if(maintenanceFeedbackObj && maintenanceFeedbackObj.Severity) {
            maintenanceFeedbackObj.Severity =
              maintenanceFeedbackObj && maintenanceFeedbackObj.Severity && maintenanceFeedbackObj.Severity.value;
          }
          data.maintenance_feedback = maintenanceFeedbackObj;
          delete data.fault_feedback;
          delete data.failure_feedback;
        } else if (data.feedback_type === "FAULT_REPORT") {
          data.fault_feedback.map( fault => faultFeedbackObj[fault.label] = fault.value);
          if(faultFeedbackObj && faultFeedbackObj.Severity) {
            faultFeedbackObj.Severity =
              faultFeedbackObj && faultFeedbackObj.Severity && faultFeedbackObj.Severity.value;
          }
          data.fault_feedback = faultFeedbackObj;
          delete data.maintenance_feedback;
          delete data.failure_feedback;
        } else if (data.feedback_type === "FAILURE_REPORT") {
          data.failure_feedback.map( failure => failureFeedbackObj[failure.label] = failure.value);
          if(failureFeedbackObj && failureFeedbackObj.Severity) {
            failureFeedbackObj.Severity =
              failureFeedbackObj && failureFeedbackObj.Severity && failureFeedbackObj.Severity.value;
          }
          data.failure_feedback = failureFeedbackObj;
          delete data.maintenance_feedback;
          delete data.fault_feedback;
        }

        delete data.formType;
        this.props.createOrUpdateFeedback(data);
      }
    }
    this.toggle();
  };

  configureFormData = selectedFeedback => {
    selectedFeedback =
      selectedFeedback && Object.keys(selectedFeedback).length > 0
        ? selectedFeedback : {};
    let newSelectedFeedback = JSON.parse(JSON.stringify(selectedFeedback));

    newSelectedFeedback.maintenance_feedback = [
      { value: '', label: 'Action' },
      { value: '', label: 'Severity' },
      { value: '', label: 'Date Detected' },
      { value: '', label: 'Cause' },
    ];

    newSelectedFeedback.failure_feedback = [
      { value: '', label: 'Failure Type' },
      { value: '', label: 'Severity' },
      { value: '', label: 'Date Detected' },
      { value: '', label: 'Cause' },
    ];

    newSelectedFeedback.fault_feedback = [
      { value: '', label: 'Fault Label' },
      { value: '', label: 'Severity' },
      { value: '', label: 'Date Detected' },
      { value: '', label: 'Cause' },
    ];

    if (selectedFeedback.feedback_type) {
      let new_label = selectedFeedback.feedback_type.replace(/_/g,' ');
      newSelectedFeedback.feedback_type = { value: selectedFeedback.feedback_type, label:new_label };

      if ( selectedFeedback.feedback_type === 'MAINTENANCE' ) {
        newSelectedFeedback.maintenance_feedback[0].value =
          selectedFeedback.maintenance_feedback && selectedFeedback.maintenance_feedback["Action"]
            ? selectedFeedback.maintenance_feedback["Action"] : '';

        newSelectedFeedback.maintenance_feedback[1].value =
          selectedFeedback.maintenance_feedback && selectedFeedback.maintenance_feedback["Severity"]
            ? selectedFeedback.maintenance_feedback["Severity"] : '';

        newSelectedFeedback.maintenance_feedback[2].value =
          selectedFeedback.maintenance_feedback && selectedFeedback.maintenance_feedback["Date Detected"]
            ? selectedFeedback.maintenance_feedback["Date Detected"] : '';

        newSelectedFeedback.maintenance_feedback[3].value =
          selectedFeedback.maintenance_feedback && selectedFeedback.maintenance_feedback["Cause"]
            ? selectedFeedback.maintenance_feedback["Cause"] : '';

        newSelectedFeedback.maintenance_feedback[4].value =
          selectedFeedback.maintenance_feedback && selectedFeedback.maintenance_feedback["Comments"]
            ? selectedFeedback.maintenance_feedback["Comments"] : '';
      } else if ( selectedFeedback.feedback_type === 'FAULT_REPORT' ) {
        newSelectedFeedback.fault_feedback[0].value =
          selectedFeedback.fault_feedback && selectedFeedback.fault_feedback["Fault Label"]
            ? selectedFeedback.fault_feedback["Fault Label"] : '';

        newSelectedFeedback.fault_feedback[1].value =
          selectedFeedback.fault_feedback && selectedFeedback.fault_feedback["Severity"]
            ? selectedFeedback.fault_feedback["Severity"] : '';

        newSelectedFeedback.fault_feedback[2].value =
          selectedFeedback.fault_feedback && selectedFeedback.fault_feedback["Date Detected"]
            ? selectedFeedback.fault_feedback["Date Detected"] : '';

        newSelectedFeedback.fault_feedback[3].value =
          selectedFeedback.fault_feedback && selectedFeedback.fault_feedback["Cause"]
            ? selectedFeedback.fault_feedback["Cause"] : '';

        newSelectedFeedback.fault_feedback[4].value =
          selectedFeedback.fault_feedback && selectedFeedback.fault_feedback["Comments"]
            ? selectedFeedback.fault_feedback["Comments"] : '';
      } else if ( selectedFeedback.feedback_type === 'FAILURE_REPORT' ) {
        newSelectedFeedback.failure_feedback[0].value =
          selectedFeedback.failure_feedback && selectedFeedback.failure_feedback["Failure Type"]
            ? selectedFeedback.failure_feedback["Failure Type"] : '';

        newSelectedFeedback.failure_feedback[1].value =
          selectedFeedback.failure_feedback && selectedFeedback.failure_feedback["Date Detected"]
            ? selectedFeedback.failure_feedback["Date Detected"] : '';

        newSelectedFeedback.failure_feedback[2].value =
          selectedFeedback.failure_feedback && selectedFeedback.failure_feedback["Cause"]
            ? selectedFeedback.failure_feedback["Cause"] : '';
      }

    }

    return newSelectedFeedback;
  };

  reArrangeFeedbackList = feedbackList => {
    let newFeedbackList = [];

    feedbackList && feedbackList.length > 0 &&
    feedbackList.map( feedback => {
      if (feedback.feedback_type === 'MAINTENANCE') {
        newFeedbackList.push({
          ...feedback.maintenance_feedback,
          comments: feedback.comments,
          feedback_type: feedback.feedback_type
        });
      } else if (feedback.feedback_type === 'FAILURE_REPORT') {
        newFeedbackList.push({
          ...feedback.failure_feedback,
          comments: feedback.comments,
          feedback_type: feedback.feedback_type
        });
      } else if (feedback.feedback_type === 'FAULT_REPORT') {
        newFeedbackList.push({
          ...feedback.fault_feedback,
          comments: feedback.comments,
          feedback_type: feedback.feedback_type
        });
      }
      return feedback;
    });

    return newFeedbackList;
  };

  render () {
    const {
      dataLoaded,
      showDeleteAlert,
    } = this.state;
    const {
      t,
      loadFeedbackList,
      loadingFeedback,
      feedbackList,
      totalPages,
      deleteFeedback,
      selectedFeedback,
      selectedComponent
    } = this.props;

    const columns = [
      {
        Header: t('asset_management.feedback_label.feedback_type'),
        accessor: 'feedback_type',
        filterMethod: (filter, row) => {
          if (filter.value === "all") {
            return true;
          }

          return row[filter.id] === filter.value;
        },
        Filter: ({ filter, onChange }) =>
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
            className={'table-filter-dropdown'}
          >
            <option value="">Show All</option>
            <option value="MAINTENANCE">MAINTENANCE</option>
            <option value="FAULT_REPORT">FAULT_REPORT</option>
            <option value="FAILURE_REPORT">FAILURE_REPORT</option>
          </select>
      }, {
        Header: t('asset_management.feedback_label.issue_details'),
        accessor: 'comments',
        filterable: false,
      }, {
        Header: t('asset_management.feedback_label.severity'),
        accessor: 'Severity',
        filterable: false,
      }, {
        Header: t('asset_management.feedback_label.root_cause'),
        accessor: 'Cause',
        filterable: false,
      }, {
        Header: t('asset_management.feedback_label.date'),
        accessor: 'Date Detected',
        filterable: false,
      }
    ];

    return (
      <React.Fragment>
        {
          !dataLoaded &&
          <Row>
            <Card>
              <CardHeader>
                <div className="form__form-group-icon">
                  <LoadingIcon />
                </div>
                Loading Maintenance/Feedback History
              </CardHeader>
              <CardBody>
                <div></div>
              </CardBody>
            </Card>
          </Row>
        }

        {
          dataLoaded &&
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader >
                  { t('asset_management.feedback.title') }
                </CardHeader>
                <CardBody>
                  {this.renderActionButton2()}
                  <ReactTable
                    data={this.reArrangeFeedbackList(feedbackList)}
                    columns={columns}
                    className='feedbackList'
                    filterable
                    minRows = {0}

                    defaultFilterMethod={(filter, row) =>
                      String(row[filter.id]) === filter.value}
                    loading={loadingFeedback}
                    showPagination={true}
                    showPaginationTop={false}
                    showPaginationBottom={true}
                    pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                    pages={
                      totalPages ? totalPages : 1
                    }
                    manual
                    onFetchData={(state, instance) => {
                      let filterFieldData = '';
                      state.filtered.filter(columnName =>
                        filterFieldData = filterFieldData + '&' + columnName.id + '=' + columnName.value);

                      const sortBy =
                        state.sorted && state.sorted.length > 0 && state.sorted[0].id
                          ? state.sorted[0].id : '';

                     if (selectedComponent) {
                          loadFeedbackList({
                            component_id: selectedComponent._id,
                            page: state.page,
                            perPage: state.pageSize,
                            filterFieldData: filterFieldData,
                            sortBy: sortBy,
                          });
                      }

                    }}
                  />
                </CardBody>
              </Card>
            </Col>

            <Modal isOpen={this.state.modal} toggle={this.toggle} className={"feedback-form"}>
              <ModalHeader toggle={this.toggle}>
                {
                  selectedFeedback && selectedFeedback.length > 0
                    ? t('asset_management.feedback.form_update_title')
                    : t('asset_management.feedback.form_create_title')
                }

              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col sm="12" md={{ size: 6, offset: 3 }}>
                    <FeedbackForm
                      form_data={this.configureFormData(selectedFeedback)}
                      onSubmit={this.handleCreate}
                      onCancel={() => {
                        this.closeForm();
                      }}
                    />
                  </Col>
                </Row>
              </ModalBody>
            </Modal>
          </Row>
        }

        <DeletePopUP
          title="Are you sure, you want to delete this Asset?"
          showDeleteAlert={ showDeleteAlert }
          onDelete={() => {
            deleteFeedback(selectedFeedback);
            return this.setState({ showDeleteAlert: false });
          }}
          onCancel={() => this.setState({ showDeleteAlert: false })
          }
        />

      </React.Fragment>
    );
  }
}

MaintenanceOrFeedbackHistoryList.propTypes = {
  t: PropTypes.func.isRequired,
  loadFeedbackList: PropTypes.func.isRequired,
  openFeedback: PropTypes.func.isRequired,
  deleteFeedback: PropTypes.func.isRequired,
  feedbackList: PropTypes.array,
  selectedFeedback: PropTypes.any,
};

function mapStateToProps({ feedback, component }) {
  return {
    loadingFeedback: feedback.loadingFeedback,
    feedbackList: feedback.feedbackList,
    totalPages: feedback.totalPages,
    selectedFeedback: feedback.selectedFeedback,
    selectedComponent: component.selectedComponent,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadFeedbackList,
      openFeedback,
      createOrUpdateFeedback,
      deleteFeedback,
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MaintenanceOrFeedbackHistoryList)
);
